import { Turbo } from '@hotwired/turbo-rails'
import './controllers/index_user'
import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

Turbo.config.drive.progressBarDelay = 200

document.addEventListener('turbo:before-cache', function () {
  const flash_message_element = document.querySelector('.flash')
  if (flash_message_element) {
    flash_message_element.remove()
  }
})
